<template>
  <div id="edit-api" class="editor-modal">
    <form @submit="onCreate">
      <h2>{{ $t("edit-scopes.title") }}</h2>

      <div class="quick-selectors">
        <button type="button" @click="addAll()" class="btn btn-xs">+ {{ $t("edit-scopes.add-all") }}</button>
        <button type="button" @click="clearScopes()" class="btn btn-xs">- {{ $t("edit-scopes.clear") }}</button>
      </div>
      <div class="checkbox-wrapper">
        <checkbox
          v-for="scope in scopes"
          :key="scope.uniqueName"
          :lightLabel="true"
          :label="scope.prettyName"
          :name="scope.uniqueName"
          :value="scope.uniqueName"
          v-model="checkedNames"
          @change="addScope()"
        />
      </div>
      <div class="actions">
        <button type="submit" class="btn btn-md btn-primary" @click="onCreate" v-bind:loading="true">
          {{ $t("edit-scopes.save") }}
        </button>
        <button class="btn btn-md btn-secondary" type="reset" @click="$emit('close')">
          {{ $t("users.add-user-btn-cancel") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Checkbox from "@/components/Checkbox";
export default {
  props: {
    onSave: Function,
    inputPlaceholder: String,
    title: String,
    scopes: Array,
    currentScopes: Array,
    name: String,
    checked: Boolean,
    id: Number
  },
  data() {
    return {
      checkedNames: this.currentScopes,
      apiKey: {
        name: this.name,
        scopes: this.currentScopes,
        id: this.id
      }
    };
  },
  computed: {
    valid() {
      return this.apiKey;
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      // this.onCreate()
      this.onSave(this.apiKey);
    },

    onCreate(evt) {
      evt.preventDefault();
      this.onSave(this.apiKey);
      this.$emit("close");
    },
    addScope() {
      this.apiKey.scopes = this.checkedNames;
    },

    clearScopes() {
      this.checkedNames = [];
      this.apiKey.scopes = this.checkedNames;
    },

    addAll() {
      this.scopes.forEach((scope) => {
        this.checkedNames.push(scope.uniqueName);
      });
    }
  },
  components: {
    Checkbox
  }
};
</script>

<style lang="less">
#edit-api {
  padding: 30px 25px 25px 25px;
  button {
    margin-right: 10px;
  }
  .checkbox-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 12px 0;
  }
}
</style>
